/*
 * TEMPORARY — bundle email campaign helper.
 * A single Klaviyo/email link like
 *   /?bundle1=<variantId>&bundle2=<variantId>[&bundle3=...]
 * adds each variant to the cart, then opens the Upcart drawer.
 * Works on any landing page. Safe to delete (this file + the script_tag line
 * in theme.liquid) once the campaign is over.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var ids = [];
  var bundleKeys = [];

  params.forEach(function (value, key) {
    if (/^bundle\d+$/i.test(key)) {
      bundleKeys.push(key);
      var id = parseInt(value, 10);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
  });

  if (!ids.length) return;

  // Don't re-add if the customer reloads the same link.
  try {
    var token = 'bundle:' + window.location.search;
    if (sessionStorage.getItem(token)) return;
    sessionStorage.setItem(token, '1');
  } catch (e) {}

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      bundleKeys.forEach(function (k) { url.searchParams.delete(k); });
      window.history.replaceState({}, document.title, url.pathname + (url.search ? url.search : '') + url.hash);
    } catch (e) {}
  }

  function openDrawer(attempt) {
    attempt = attempt || 0;
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); } catch (e) {} return; }
    if (attempt < 25) { setTimeout(function () { openDrawer(attempt + 1); }, 300); }
  }

  var items = ids.map(function (id) { return { id: id, quantity: 1 }; });

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      cleanUrl();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      openDrawer(0);
    })
    .catch(function (err) { console.warn('[Bundle] add to cart failed', err); });
})();
